import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from './en'
import zhLocale from './zh'
import jpLocale from './jp'
import twLocale from './tw'

import dyLocale from './de'
import fyLocale from './fr'
import tyLocale from './th'
import xbyLocale from './es'
import ynLocale from './vn'
import hyLocale from './kr'
import { getLang } from '@/utils/auth'

Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale
  },
  zh: {
    ...zhLocale
  },
  tw: {
    ...twLocale
  },
  jp: {
    ...jpLocale
  },
  de: {
    ...dyLocale
  },
  fr: {
    ...fyLocale
  },
  th: {
    ...tyLocale
  },
  vn: {
    ...ynLocale
  },
  es: {
    ...xbyLocale
  },
  kr: {
    ...hyLocale
  },
}

const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: getLang(),
  // set locale messages
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js